<template>
  <a-table
    :columns="add ? columns : columns2"
    :row-key="(record) => record.id"
    :data-source="dataSource"
    size="middle"
    :pagination="false"
  >
    <template #bodyCell="{ column, record, index }">
      <template v-if="column.key === 'tid'">
        <div class="ml16 mb16">{{ index + 1 }}</div>
      </template>
      <!-- && isStatus == null -->
      <template v-if="column.key === 'url'">
        <div class="ml16 mb16">
          <a
            style="color: #1e8ef2"
            :href="record.url"
            v-if="record.url"
            target="_blank"
            >下载模板</a
          >
        </div>
      </template>

      <template v-if="column.key === 'materialTemplateFile'">
        <div class="ml16 mb16">
          <a
            style="color: #1e8ef2"
            :href="record.materialTemplateFile"
            v-if="record.materialTemplateFile"
            target="_blank"
          >
            下载模板
            <!-- {{ getFileName(record.materialTemplateFile) }} -->
          </a>
        </div>
      </template>

      <template v-if="column.key === 'files'">
        <div v-if="!add" class="ml16 mb16">
          <a
            style="color: #1e8ef2"
            :href="record.uploadFile"
            v-if="record.uploadFile"
            target="_blank"
            >{{ getFileName(record.uploadFile) }}</a
          >
        </div>
        <div v-else class="ml16 mb16">
          <a
            style="color: #1e8ef2"
            :href="record.addUrl"
            v-if="record.addUrl"
            target="_blank"
            >{{ getFileName(record.addUrl) }}</a
          >
        </div>
      </template>
      <!-- && isStatus !== null -->
      <template v-else-if="column.key === 'action'">
        <div class="ml16 mb16">
          <!-- <a style="color: #1E8EF2;" @click="detail(record)">选择上传</a> -->
          <uploadText
            :info="record"
            pathName="car"
            @uploadFinished="uploadFinished"
          />
        </div>
      </template>
      <template v-else-if="column.key === 'action2'">
        <div v-if="!add">
          <span
            class="ml16 mt16 mb16"
            @click="preview(record)"
            :style="
              record.uploadFile
                ? { color: '#1e8ef2' }
                : { pointerEvents: 'none', color: '#ccc' }
            "
          >
            <a>预览</a></span
          >
          <span
            class="ml16 mt16 mb16"
            :style="
              record.uploadFile
                ? { color: '#1e8ef2' }
                : { pointerEvents: 'none', color: '#ccc' }
            "
          >
            <a :href="record.uploadFile" target="_blank">下载</a></span
          >
        </div>

        <div v-else>
          <span
            class="ml16 mt16 mb16"
            :style="
              record.addUrl
                ? { color: '#1e8ef2' }
                : { pointerEvents: 'none', color: '#ccc' }
            "
            @click="preview(record)"
          >
            <a>预览</a></span
          >
          <span
            class="ml16 mt16 mb16"
            :style="
              record.addUrl
                ? { color: '#1e8ef2' }
                : { pointerEvents: 'none', color: '#ccc' }
            "
          >
            <a :href="record.addUrl" target="_blank">下载</a></span
          >
        </div>
      </template>
    </template>
  </a-table>
</template>

<script setup>
import {
  ref,
  reactive,
  watch,
  onBeforeMount,
  defineProps,
  defineExpose,
} from "vue";
import uploadText from "@/components/uploadText/index.vue";
import { fileUpdateById } from "@/api/qualification/index";
import moment from "moment";
import { message } from "ant-design-vue";
import { Base64 } from "js-base64";

const props = defineProps({
  //测试类型
  type: {
    type: String,
    default: () => "0",
  },
  data: {
    type: Array,
    default: () => {
      return [];
    },
  },
  add: {
    type: Boolean,
    default: () => true,
  },
  //资质id,单个更新材料时使用
  id: {
    type: String,
    default: () => "",
  },
});

const columns = [
  {
    title: "序号",
    dataIndex: "tid",
    key: "tid",
    width: "100px",
  },
  {
    title: "附件名称",
    dataIndex: "displayName",
    key: "displayName",
    width: "40%",
    ellipsis: true,
  },
  {
    title: "模板",
    key: "url",
    dataIndex: "url",
    width: "15%",
  },
  {
    title: "已上传文件",
    key: "files",
    dataIndex: "files",
    width: "15%",
  },
  {
    title: "材料上传",
    key: "action",
    width: "200px",
  },
  {
    title: "文件预览/下载",
    key: "action2",
    width: "200px",
  },
];

const columns2 = [
  {
    title: "序号",
    dataIndex: "tid",
    key: "tid",
    width: "100px",
  },
  {
    title: "附件名称",
    dataIndex: "materialTemplateName",
    key: "materialTemplateName",
    width: "40%",
    ellipsis: true,
  },
  {
    title: "模板",
    key: "materialTemplateFile",
    dataIndex: "materialTemplateFile",
    width: "15%",
  },
  {
    title: "已上传文件",
    key: "files",
    dataIndex: "files",
    width: "15%",
  },
  {
    title: "材料上传",
    key: "action",
    width: "200px",
  },
  {
    title: "文件预览/下载",
    key: "action2",
    width: "200px",
  },
];

let dataSource = ref([]);

watch(
  () => props.type,
  (val) => {
    // getData(val)
  }
);

watch(
  () => props.data,
  (val) => {
    dataSource.value = val;
    console.log(val, 222);
  },
  { immediate: true }
);
/**
 * 获取申请所需材料清单
 * key  测试类型   根据不同的测试类型   获取不同的材料清单
 */
function getData(key) {
  for (let i = 0; i < 3; i++) {
    dataSource.value.push({
      ranking: i + 1,
      attachmentName: "智能网联汽车道路测试自我声明书",
      status: "下载模板",
    });
  }
}

let finishData = ref([]);
function uploadFinished(url, row) {
  console.log(url);
  let obj = {
    materialTemplateFile: row.url || row.materialTemplateFile,
    materialTemplateId: row.id,
    materialTemplateName: row.displayName || row.materialTemplateName,
    uploadFile: url,
    sort: row.sort,
  };
  if (props.add) {
    row.addUrl = url;
  }
  if (!props.add) {
    //编辑
    obj.id = row.id;
    obj.materialTemplateId = row.materialTemplateId;
  }
  if (props.id) {
    let time = moment().format("YYYY-MM-DD HH:mm:ss");
    let data = {
      ...obj,
      // id:props.id,
      uploadTime: time,
    };
    fileUpdateById(data).then((res) => {
      if (res.code == 200) {
        message.success("上传成功");
      }
    });
  }
  dataSource.value.map((item) => {
    if (props.add) {
      if (item.id == obj.materialTemplateId) {
        item.uploadFile = obj.uploadFile;
      }
    } else {
      if (item.id == obj.id) {
        item.uploadFile = obj.uploadFile;
      }
    }
  });
}

const getFileName = (url) => {
  if (!url || typeof url !== 'string') {
    return '';
  }

  let arr = url.split("/");
  let file = arr[arr.length - 1];

  // 如果文件名包含点号且不以点号开头，则截取掉后缀
  const dotIndex = file.lastIndexOf(".");
  if (dotIndex > 0) {
    return file.substring(0, dotIndex);
  }

  return file;
};

const preview = (record) => {
  console.log(record);
  // 当前页面 在线预览
  //   imgVisbleURL.value = 'http://192.168.3.35:8012/onlinePreview?url=' + encodeURIComponent(Base64.encode(record.uploadFile))
  //   visible.value = true
  let url = "";
  // 开发环境
  if (process.env.NODE_ENV == "development") {
    url = process.env.VUE_APP_PREVIEW_URL;
  } else if (process.env.NODE_ENV == "production") {
    //生产环境
    url = 'http://192.168.74.107:8080' + "/file-online-preview" + "/onlinePreview?url=";   // 5127
    // url = 'http://124.221.243.22:8012' + "/onlinePreview?url=";   // 5127
    // url = 'http://124.70.161.33:9008' + "/kkFileView/onlinePreview?url=";   // 5138
    // url = window.location.origin + "/api/file-online-preview" + "/kkFileView/onlinePreview?url=";
  }
  if (props.add) {
    // 新增 在线预览 跳转新页面
    window.open(url + encodeURIComponent(Base64.encode(record.addUrl)));
  } else {
    // 编辑 在线预览 跳转新页面
    window.open(url + encodeURIComponent(Base64.encode(record.uploadFile)));
  }
};

defineExpose({
  dataSource,
});
</script>
